import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface UpdateErgonomicWorkAnalysisImageDescriptionParams {
	id: string;
	image_id: string;
	description: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useUpdateErgonomicWorkAnalysisImageDescription = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UpdateErgonomicWorkAnalysisImageDescriptionParams) =>
			Service.updateImageDescription(params),
		onError: () => {
			message.error(I18n.get('Error updating image description'));
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries([QUERY_KEYS.GET_ERGONOMIC_WORK_ANALYSIS]);
			message.success(I18n.get('Image description updated successfully'));
		}
	});
};
